// extracted by mini-css-extract-plugin
export default {"root":"LandingTopbar_root__g-GYW","navigation":"LandingTopbar_navigation__3agGp"};